import { Injectable, } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class SettingsService extends BaseService {
  public static _dateFormats: any = {};
  private _settings = {};
  constructor() {
    super()
  }

  loadSettings() {
    return this.http.get(`${this.absoluteHostNameURL}AppData/settings.json`).pipe(tap((res: any) => {
      this._settings = res;
      return res;
    }))
  }
  
  public get settings(): any {
    return this._settings;
  }


    downloadBasedOnURL(url: string, isDms = true): Observable<any> {
        //if (isDms)
        //    return super.requestDms(url, {}, 'get', { responseType: 'blob' });
        //else
            return super.requestbyUrl(url, {}, 'get', { responseType: 'blob' });
    }
    public get dateFormats(): any {
      return  SettingsService._dateFormats;
  }
}
